import { useEffect, useLayoutEffect, useRef } from 'react'
import { useMotionValue, useScroll } from 'motion/react'
import { useLocation } from 'react-router-dom'

export function useStableScrollProgress() {
  const { scrollYProgress } = useScroll({ trackContentSize: true })
  const stableProgress = useMotionValue(0)
  const { pathname } = useLocation()
  const isSettled = useRef(false)

  useLayoutEffect(() => {
    isSettled.current = false
  }, [pathname, stableProgress])

  useEffect(() => {
    let timeoutId: NodeJS.Timeout
    const resizeObserver = new ResizeObserver(() => {
      isSettled.current = false
      clearTimeout(timeoutId)

      timeoutId = setTimeout(() => {
        const e1 = document.documentElement
        const progress = e1.scrollTop / (e1.scrollHeight - e1.clientHeight)
        stableProgress.set(Number.isNaN(progress) ? 0 : 0.05 + 0.95 * progress)
        isSettled.current = true
      }, 100)
    })

    if (document.body) {
      resizeObserver.observe(document.body)
    }

    return () => {
      clearTimeout(timeoutId)
      resizeObserver.disconnect()
    }
  }, [])

  useEffect(() => {
    return scrollYProgress.on('change', (v) => {
      const raf1 = requestAnimationFrame(() => {
        if (isSettled.current) {
          stableProgress.set(0.05 + 0.95 * v)
        }
      })
      return () => cancelAnimationFrame(raf1)
    })
  }, [scrollYProgress, stableProgress])

  return { stableProgress }
}
